{
  "durations": {
    "burst": 0.7,
    "flash": 0.45,
    "enter": 0.35,
    "exit": 0.25,
    "stagger": 0.06,
    "morph": 0.5
  },
  "easings": {
    "emphasized": [0.2, 0, 0, 1],
    "standard": [0.4, 0, 0.2, 1],
    "decelerate": [0, 0, 0.2, 1],
    "ringExpand": "easeOut"
  }
}
